module.exports = __webpack_public_path__ + "static/tony-001-404564d256759057434c158f6066cf12.jpg";